<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eOn1Ja/tc-custom/9781609455927.jpg?1726755940126" alt="This image is the cover for the book Lying Life of Adults"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lying Life of Adults
      </h1>
      <p class="bookDescription body article font2">
        <b>The <i>New York Times</i>–bestseller set in a divided Naples—now a Netflix original series—from the acclaimed author of <i>My Brilliant Friend</i> and <i>The Lost Daughter</i>.</b><br/><br/><b>A BEST BOOK OF 2020</b><br/><br/><b>The Washington Post</b><b>·</b><b>O, The Oprah Magazine</b><b>·</b><b>TIME Magazine</b><b>·</b><b>NPR</b><b>·</b><b>People Magazine</b><b>·</b><b>The New York Times Critics</b><b>·</b><b>The Guardian</b><b>·</b><b>Electric Literature</b><b>·</b><b>Financial Times</b><b>·</b><b>Times UK</b><b>·</b><b>Irish Times</b><b>·</b><b>New York Post</b><b>·</b><b>Kirkus Reviews</b><b>·</b><b>Toronto Star</b><b>·</b><b>The Globe and Mail</b><b>·</b><b>Harper’s Bazaar</b><b>·</b><b>Vogue UK</b><b>·</b><b>The Arts Desk</b><br/><br/>Giovanna’s pretty face is changing, turning ugly, at least so her father thinks. Giovanna, he says, looks more like her Aunt Vittoria every day. But can it be true? Is she really changing? Is she turning into her Aunt Vittoria, a woman she hardly knows but whom her mother and father clearly despise? Surely there is a mirror somewhere in which she can see herself as she truly is.<br/><br/>Giovanna is searching for her reflection in two kindred cities that fear and detest one another: Naples of the heights, which assumes a mask of refinement, and Naples of the depths, a place of excess and vulgarity. She moves from one to the other in search of the truth, but neither city seems to offer answers or escape.<br/><br/><b>“Another spellbinding coming-of-age tale from a master.” —</b><b><i>People Magazine</i>, Top 10 Books of 2020</b><br/><br/><b>“The literary event of the year.” —</b><b><i>Elle</i></b><br/><br/><b>“Ms. Ferrante once again, with undiminished skill and audacity, creates an emotional force field that has at its heart a young girl on the brink of womanhood.” —<i>The Wall Street Journal</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elena Ferrante
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Europa Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bd252450